import React from "react"
import { makeStyles } from "tss-react/mui"

import { Box, Icon, IconProps } from "@mui/material"
import { ReactComponent as large_left } from "./assets/large_left.svg"
import { ReactComponent as large_right } from "./assets/large_right.svg"
import { ReactComponent as column_1 } from "./assets/column_1.svg"
import { ReactComponent as column_2 } from "./assets/column_2.svg"
import { ReactComponent as tabbed } from "./assets/tabbed.svg"
import { ReactComponent as stacked } from "./assets/stacked.svg"
import { lightBlue } from "../themes/palette"
import { formatDataAutomationId } from "@masteryprep/qti-components"

const useStyles = makeStyles()(({ spacing, palette, breakpoints }) => ({
  xsmall: {
    fontSize: "0.6875rem"
  },
  small: {
    fontSize: "0.875rem"
  },
  med: {
    fontSize: "1rem"
  },
  large: {
    fontSize: "1.25rem"
  },
  inherit: {
    fontSize: "inherit"
  }
}))

interface Props {
  size?: "xsmall" | "small" | "med" | "large" | "inherit"
  IconProps?: IconProps
  style?: any
  className?: string
  component?: React.FC
  dataAutomationId?: string
}

export const RedoIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-redo", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const UndoIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-undo", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}

export const AddIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-plus-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}

export const ListIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fa",
        "fa-solid",
        "fa-rectangle-list",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}

export const SubtractIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-minus-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const MenuIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-ellipsis-h", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowBackIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-arrow-left", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RemoveIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-times-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const DeleteIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-trash", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RenameIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-i-cursor", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PublishIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-rocket", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const DuplicateIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-copy", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const LinkIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-link", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const FilterFilledIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-filter", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const FilterEmptyIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("far", "fa-filter", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const EditIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-pen", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const HintIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-lightbulb", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PresentationIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-presentation", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const VideoIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-video", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ImageIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-image", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ContentIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-font-case", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const QuestionIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-question", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const VideoLinkIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fab", "fa-youtube", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const VideoRecordIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-webcam", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const UploadIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-upload", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const LibraryIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-photo-video", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const TranscriptIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-file-alt", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PlayIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-play", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PauseIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-pause", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ViewIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-eye", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}

export const ReportIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-pennant", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const OneColumnIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-square", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const BalancedColumnsIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-pause", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const LargeLeftColumnIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-pause", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const LargeRightColumnIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-pause", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ExpandMoreIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fal", "fa-angle-down", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CloseIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-times",
        classes[props.size || "small"],
        props.className
      )}
      {...(props?.dataAutomationId
        ? { "data-automation-id": formatDataAutomationId(props.dataAutomationId) }
        : {})}
      {...props.IconProps}
    />
  )
}
export const ArrowCircleLeftIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-arrow-circle-left",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const ArrowCircleRightIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-arrow-circle-right",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const GripVerticalIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-grip-vertical", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const FeedbackIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-comment-alt-dots",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const ExternalLinkIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-external-link", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RevealUpIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-angle-up", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RevealDownIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-angle-down", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const BreadcrumbIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-angle-right", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const FabAddIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-plus", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const DropdownIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-caret-down", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const DebugIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-debug", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const BranchIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("far", "fa-network-wired", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SettingsIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-cog", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const LayoutsIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-bring-forward", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const AnswerIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-ballot", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CircleDownIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-arrow-alt-circle-down",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const CircleUpIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-arrow-alt-circle-up",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const TextSizeIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("far", "fa-text-size", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowsHorizontalIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrows-alt-h", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RefreshIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-sync", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowsAltIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrows-alt", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CropIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-crop", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SearchIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-search", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SearchMinusIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-search-minus", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SearchPlusIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-search-plus", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowUpIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrow-up", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowDownIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrow-down", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowLeftIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrow-left", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowRightIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrow-right", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RotateLeftIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-undo", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RotateRightIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-undo",
        "fa-flip-horizontal",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const ArrowsVerticalIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrows-alt-v", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CheckIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-check", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CheckCircleIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-check-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CircleIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CheckCircleOutlinedIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("far", "fa-check-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CircleOutlinedIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("far", "fa-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ExpandIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-expand", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CompressIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-compress", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const MinusSquareIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-minus-square", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PlusSquareIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-plus-square", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const VolumeUpIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-volume-up", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const VolumeMuteIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-volume-mute", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const HandPointRightIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-hand-point-right",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const LayersIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-layer-group", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const GridViewIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-th", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ListViewIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-th-list", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const LargeLeftIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(classes[props.size || "small"])}
      component={large_left}
    />
  )
}
export const LargeRightIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(classes[props.size || "small"])}
      component={large_right}
    />
  )
}
export const BalancedIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(classes[props.size || "small"])}
      component={column_2}
    />
  )
}
export const CenteredColumnIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(classes[props.size || "small"])}
      component={column_1}
    />
  )
}
export const TabbedIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(classes[props.size || "small"])}
      component={tabbed}
    />
  )
}
export const StackedIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(classes[props.size || "small"])}
      component={stacked}
    />
  )
}
export const CutIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-cut", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const VolumeIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-volume", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const MuteIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fad ", "fa-volume-slash", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const FullscreenIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("far ", "fa-expand-wide", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CaptioningIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-closed-captioning",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const FileAltIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-file-alt", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const WordbankIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-book", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PDFFileIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-file-pdf", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CircleExclamationIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fal",
        "fa-exclamation-circle",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}

export const CircleListCheckIcon = (props: Props) => {
  const { cx } = useStyles()
  return (
    <Box
      sx={{
        width: "1rem",
        height: "1rem",
        borderRadius: "50%",
        background: lightBlue[600],
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Icon
        style={props.style}
        className={cx("fa-sharp", "fa-solid", "fa-list-check")}
        {...props.IconProps}
        sx={{ fontSize: "0.5rem", color: "white" }}
      />
    </Box>
  )
}

export const TringleExclamationIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fal",
        "fa-exclamation-triangle",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
